<template>
  <AddButton btnname="Import" iconClass="pi pi-file-excel" @click="triggerFileInput"></AddButton>
  <input type="file" ref="fileInput" @change="handleFileUpload" accept=".xlsx, .xls" style="display: none" />
</template>

<script lang="ts">
import { defineComponent, ref, h, computed, onMounted, onUnmounted } from "vue";
import CommonService from "../../modules/Inventory/Service/CommonService";


export default defineComponent({
  setup(_, { emit }) {
    const fileInput: any = ref(null);

    const triggerFileInput = () => {
      if (fileInput.value) {
        fileInput.value.click();
      }
    };

    const handleFileUpload = async (event: Event) => {
      debugger;
      const input = event.target as HTMLInputElement;
      const file = input.files ? input.files[0] : null;
      if (file) {
        try {
          // Create a FormData object to send the file
          const formData = new FormData();
          formData.append("file", file);

          let DataResponse = await CommonService.ExcelFileUpload(formData);

          console.log("File uploaded successfully", DataResponse);

          emit("ExcelDataImport", DataResponse);
        } catch (error) {
          console.error("Error uploading file", error);
        }
      }
    };
    return { fileInput, triggerFileInput, handleFileUpload };
  },
});
</script>
